import React from 'react';
import '../../ProductBase.css';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { getMainProductImage } from '../../utils/productUtils';
import { getProductsByType } from '../../services/productService';
import { ProductType } from '../../context/CartContext';

const products = getProductsByType(ProductType.LOCALS);

const ShopLocals: React.FC = () => {
  const navigate = useNavigate();


  return (

    <div className="subproduct-page">
      <div className="shop-container">
        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <h2 className="product-name">
                {product.name}
              </h2>
              {product.text_options && (
                  <div className="product-text-options">
                    <select className="street-name-select">
                      <option value="">Select a street name</option>
                      {product.text_options.map((text) => (
                        <option key={text} value={text}>{text}</option>
                      ))}
                    </select>
                  </div>
                )}
              <div className="product-image-wrapper">
                <img 
                  src={getMainProductImage(product)} 
                  alt={product.name} 
                  className="product-image" 
                  onClick={() => navigate(`/product/${product.id}`)}
                />
              </div>

              <div className="product-info">
                <p className="product-price">${product.price.toFixed(2)}</p>
                <div className="product-actions">
                  <button onClick={() => navigate(`/product/${product.id}`)} className='detail-button'>
                    Customize
                  </button>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShopLocals;
